module.exports = __webpack_public_path__ + "img/vis_18.41dcf9b0.jpg";